import { Button, Tooltip } from '@mui/material'
import { useEffect, useState } from 'react'

type TotalHourProps = {
  type: string
  start_end: string
  totalWork: number
}
export const TotalHour = ({ totalWork, start_end, type }: TotalHourProps) => {
  const [isWrong, setIsWrong] = useState(false)
  useEffect(() => {
    // Check for half-day off types and total work less than 4 hours
    const isHalfDayOff = ['Off_P_0.5', 'Off_U_0.5', 'Off_S_0.5', 'Off_M_0.5'].includes(type)
    setIsWrong((isHalfDayOff && totalWork < 4) || (!isHalfDayOff && totalWork < 8))
  }, [type, totalWork])
  return (
    <Tooltip
      title={<p className="whitespace-pre-line">{start_end}</p>}
      style={{ whiteSpace: 'pre-line' }}
      placement="top"
    >
      <Button
        variant="outlined"
        color={isWrong ? 'error' : 'primary'}
        size="small"
        className="px-2 min-w-fit lowercase "
      >
        {Number(totalWork.toFixed(2))}h
      </Button>
    </Tooltip>
  )
}
